import React from 'react';
import { WMICDateTimeService } from 'wmic-pe-portals-utils-js';
import { useTranslator } from '@jutro/locale';
import { WMICHeading } from 'wmic-pe-components-platform-react';
import styles from './WMICNotesForUnderwriterList.module.scss';
import messages from './WMICNotesForUnderwriterList.messages';

const WMICNotesForUnderwriterList = ({ notesSentToUnderwriter }) => {
    const translator = useTranslator();
    const notesSentToUnderwriterTitle = translator(messages.notesSentToUnderwriterTitle);

    const renderUWNoteItem = (note, index) => (
        <div key={index} className={styles.note}>
            <div>{note.body}</div>
            <div className={styles.uwNoteAuthorAndDate}>
                {`${note.authorName}, ${WMICDateTimeService.toMidnightDate(note.createdDate)}`}
            </div>
        </div>
    );

    return (
        <div className={styles.notesSentToUnderwriterContainer}>
            <WMICHeading bold variant="h2" size="h2" title={notesSentToUnderwriterTitle} />
            <div>{notesSentToUnderwriter?.map(renderUWNoteItem)}</div>
        </div>
    );
};

export default WMICNotesForUnderwriterList;
